import { render, staticRenderFns } from "./UploadSelector.vue?vue&type=template&id=09817ba2&scoped=true"
import script from "./UploadSelector.vue?vue&type=script&lang=js"
export * from "./UploadSelector.vue?vue&type=script&lang=js"
import style0 from "./UploadSelector.vue?vue&type=style&index=0&id=09817ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09817ba2",
  null
  
)

export default component.exports